import React from 'react';
import {Badge} from 'reactstrap';
import './CheckoffElement.scss'

const CheckoffElement = (props) => {
  return (
    <div className='checkoff-element'>
      <div>{props.prompt}</div>
      <div className='confirmation'>
        {props.isChecked ? (
          <Badge color="success">{props.checkoffPrompt || "I Agree"}</Badge>
        ) : (
          <Badge color="danger">No Response</Badge>
        )}
      </div>
    </div>
  );
};

export default CheckoffElement;
